import Vue from 'vue'
import Vuex from 'vuex'
import socket from './socketPlugin'
import game from './gameModule'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    game
  },
  plugins: [
    socket()
  ]
})
